import ISubmissionLinkVerifiedEmailView from 'types/ISubmissionLinkVerifiedEmailView'

export const enterpriseInitiativeLoaderInitialState = {
  isLoadingEnterpriseInitiativeInfo: false,
  enterpriseInitiativeInfo: null as ISubmissionLinkVerifiedEmailView
}

export type EnterpriseInitiativeLoaderState = typeof enterpriseInitiativeLoaderInitialState
